import { useState } from 'react';

import { Locale } from 'modules/domains/template';
import { TemplateLocale } from 'modules/graphql';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_SIZES, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useLocalesQueryContext } from 'modules/campaigns/lib/contexts/LocalesQueryContext';

import { DefaultLocaleSelectFormField } from '../../common/DefaultLocaleSelectFormField';
import { useTranslations } from '../../hooks/useTranslations';

export const DEFAULT_LOCALE_MODAL_TEST_IDS = {
  btnSave: 'locale-default-modal-btn-save',
  header: 'locale-default-modal-header',
  modal: 'locale-default-modal',
};

export type Variables = {
  templateId: number;
  locale: TemplateLocale;
};

export type DefaultLocaleModalProps = {
  closeModal: () => void;
  onDefaultChanged: (variables: Variables) => void;
  templateId: number;
};

export const DefaultLocaleModal = ({
  closeModal,
  onDefaultChanged,
  templateId,
}: DefaultLocaleModalProps) => {
  const { t } = useTranslations();
  const { activeTemplateLocales, templateDefaultLocale } = useLocalesQueryContext();
  const [defaultLocale, setDefaultLocale] = useState<Locale>(templateDefaultLocale);

  const handleSelect = (val: Locale) => {
    setDefaultLocale(val);
  };

  const onSave = () => {
    const variables = {
      templateId,
      locale: {
        name: defaultLocale.tag,
      },
    };

    onDefaultChanged(variables);
  };

  return (
    <Modal
      data-test={DEFAULT_LOCALE_MODAL_TEST_IDS.modal}
      id={DEFAULT_LOCALE_MODAL_TEST_IDS.modal}
      isModalOpen={true}
      onClose={closeModal}
      withPortal
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader autoFocus={false} data-test={DEFAULT_LOCALE_MODAL_TEST_IDS.header}>
        {t('header.localeManagement')}
      </ModalHeader>

      <ModalBody>
        <DefaultLocaleSelectFormField
          onSelect={handleSelect}
          activeTemplateLocales={activeTemplateLocales}
          templateDefaultLocale={templateDefaultLocale}
        />
      </ModalBody>

      <ModalFooter>
        <Button
          data-test={DEFAULT_LOCALE_MODAL_TEST_IDS.btnSave}
          onClick={onSave}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          {t('button.save')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
